"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleI18nSingleton = exports.SimpleI18n = void 0;

var _rulesManager = require("./rules-manager");

var _localeManager = require("./locale-manager");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var MISSING_PREFIX = 'missing.i18n.translation';
/**
 * Usage: 'Some test {<name>,<format>}'
 * Example: 'Hello {name,string}'
 */

var SimpleI18n = /*#__PURE__*/function () {
  function SimpleI18n() {
    _classCallCheck(this, SimpleI18n);

    this._initialised = false;
    this._localeManager = null;
    this._rulesManager = null;
  }

  _createClass(SimpleI18n, [{
    key: "init",
    value: function init(_ref) {
      var locale = _ref.locale,
          languages = _ref.languages,
          rules = _ref.rules;
      this._initialised = true;
      this._rulesManager = new _rulesManager.RulesManager({
        rules: rules
      });
      this._localeManager = new _localeManager.LocaleManager({
        locale: locale,
        languages: languages
      });
    }
  }, {
    key: "setLocale",
    value: function setLocale(locale) {
      this._localeManager.setLocale(locale);
    }
  }, {
    key: "translate",
    value: function translate(key, args) {
      this._validateInitialised();

      var str = this._localeManager.getLanguage()[key];

      if (!str && str !== '') {
        return "[".concat(MISSING_PREFIX, ":'").concat(key, "']");
      }

      return this.process(str, args || {});
    }
  }, {
    key: "raw",
    value: function raw(key) {
      return this._localeManager.getLanguage()[key];
    }
  }, {
    key: "hasKey",
    value: function hasKey(key) {
      return key in this._localeManager.getLanguage();
    }
  }, {
    key: "process",
    value: function process(str) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._validateInitialised();

      return this._rulesManager.process(str, args || {});
    }
  }, {
    key: "_validateInitialised",
    value: function _validateInitialised() {
      if (!this._initialised) {
        throw Error('SimpleI18n needs to be initialised. Don\'t forget to call init()');
      }
    }
  }]);

  return SimpleI18n;
}(); // use singleton


exports.SimpleI18n = SimpleI18n;
var simpleI18n = new SimpleI18n();
exports.SimpleI18nSingleton = simpleI18n;